import { apiGateway, api } from "../config";

class marketService {

    getMarkets():Promise<any> {
        return api(`${apiGateway.legacyPublicAPIv1}/dictionaries/markets`, {
            method: "GET",
            headers: {
                "Cache-Control": "no-cache"
            }
        })
    }

}

export default new marketService();
